import _ from "lodash"
import useRedux from "../../utils/use_redux"
import * as actions from "../actions"

const useItem = (path, fn, undefinedVal) =>
  useRedux("items", actions, path, fn, undefinedVal)

export default useItem
